import { call, put, delay } from "redux-saga/effects";
import { userApi } from "@services/api";
import { updateUserActiveActions, updateUserStatusAction } from "../slices";
import { has } from "lodash";
import { showSuccessToast } from "@helpers";

function* updateUserActiveWorker({ payload }) {
  yield delay(300);
  try {
    yield put(updateUserActiveActions.pending());
    const response = yield call(userApi.updateUserActive, payload.data);
    yield put(updateUserActiveActions.success(response));
    
    yield put(updateUserStatusAction(payload.data));
    // payload.onChange();

    showSuccessToast("User's status updated successfully");
    if (has(payload, "onSuccess")) {
      payload.onSuccess();
    }
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(updateUserActiveActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { updateUserActiveWorker };
